import { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

// MapLibre GL is ~700 KB gzipped; pulling it lazily keeps it out of the
// app's initial bundle. Vite's manualChunks (see vite.config.ts) puts it
// in its own chunk, so the Suspense boundary unblocks once the chunk
// resolves on first navigation to /world.
const WorldView = lazy(() => import("@/components/world/WorldView"));

export const Route = createFileRoute("/world")({
  component: WorldRoute,
});

function WorldRoute() {
  return (
    <Suspense fallback={<WorldBootShell />}>
      <WorldView />
    </Suspense>
  );
}

function WorldBootShell() {
  const { t } = useTranslation("world");
  return (
    <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
      {t("map.loading")}
    </div>
  );
}
